<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent max-width="500px">
      <v-card>
        <v-card-title>
          <span class="title">เพิ่ม ปี/ภาคการศึกษา</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form v-model="valid" ref="form" lazy-validation>
            <v-container grid-list-md>
              <v-layout wrap>
                  <v-flex xs12>
                    <v-text-field label="ปีการศึกษา" v-model="item.year" :rules="[rules.required]" mask="####" hint="ตัวอย่าง 2560" persistent-hint required></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field label="ภาคการศึกษา" v-model="item.semester" mask="n" :rules="[rules.required]" hint="ตัวอย่าง 1, 2, s" persistent-hint required></v-text-field>
                  </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="grey white--text" :loading="loading" :disabled="loading" @click.native="close">ยกเลิก</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="success" :loading="loading" :disabled="loading" @click.native="onSave">บันทึก</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import swal from 'sweetalert2'

export default {
  props: ['dialog'],
  data () {
    return {
      loading: false,
      item: {
        year: null,
        semester: null
      },
      valid: false,
      rules: {
        required: (value) => !!value || 'ไม่สามารถเป็นค่าว่าง'
      },
    }
  },
  methods: {
    onSave () {
      if (this.$refs.form.validate()) {
        this.loading = true
        this.$store.dispatch('academicYear/create', this.item)
          .then((response) => {
            // console.log('onSave:', response )
            this.loading = false
            swal({
              title: 'Success!',
              type: 'success'
            }).then(response => {
              this.close()
            })
          }).catch((error) => {
            this.loading = false
            swal('Error!', error.message, 'error')
          })
      }
    },
    close: function() {
      this.$emit('dialog', false)
    },
  },
  watch: {
    
  }
}

</script>


// WEBPACK FOOTER //
// src/components/management/course/academicYear/formDialog.vue